// src/features/services/ServicesCard.jsx
import React from "react";
import { API_BASE } from "../../admin/api";
import "./services-admin.css";

export default function ServicesCard({ item, onEdit, onDelete }) {
  const img = item.cover_image ? `${API_BASE}${item.cover_image}` : null;

  return (
    <article className="services-card">
      <div className="services-card__thumb">
        {img ? (
          <img src={img} alt={item.title} loading="lazy" />
        ) : (
          <div className="services-card__thumb--empty">No Image</div>
        )}
      </div>

      <div className="services-card__body">
        <div className="services-card__status">
          <span
            className={`services-chip ${
              item.status === "published" ? "" : "services-chip--muted"
            }`}
          >
            {item.status || "draft"}
          </span>
        </div>

        <h3 className="services-card__title">{item.title}</h3>
        {item.excerpt && <p className="services-card__excerpt">{item.excerpt}</p>}

        <div className="services-card__actions">
          <button className="services-btn services-btn--ghost" onClick={() => onEdit(item)}>
            Edit
          </button>
          <button className="services-btn services-btn--danger" onClick={() => onDelete(item.id)}>
            Delete
          </button>
        </div>
      </div>
    </article>
  );
}
